// GGH Learning Hub — module catalog (members-only, hotel dashboard).
// Structure only: GGH gradually adds and reviews credible learning materials.
// Each module supports: short written lessons, images/graphics, practical hotel
// examples, key actions and an optional knowledge check (rendered when present).
// `areas` map to GGH Assessment areas so modules can be recommended against
// assessment results (e.g. low "food" score → Reducing Food Waste module).
export const LEARNING_MODULES = [
    {
        id: "intro-sustainable-hospitality",
        title: "Introduction to Sustainable & Regenerative Hospitality",
        summary: "What sustainable and regenerative hospitality means, and why it matters in everyday hotel work.",
        areas: ["management"],
    },
    {
        id: "reducing-food-waste",
        title: "Reducing Food Waste in Hotel Operations",
        summary: "Where food waste occurs in hotel kitchens, buffets and service — and how teams can help reduce it.",
        areas: ["food"],
    },
    {
        id: "water-energy-awareness",
        title: "Water & Energy Awareness",
        summary: "Everyday water and energy awareness across guest rooms, laundry and back-of-house operations.",
        areas: ["water", "energy"],
    },
    {
        id: "sustainable-housekeeping",
        title: "Sustainable Housekeeping Practices",
        summary: "Housekeeping routines that help reduce waste, water and resource use while keeping guests comfortable.",
        areas: ["waste"],
    },
    {
        id: "engaging-hotel-teams",
        title: "Engaging Hotel Teams in Sustainability",
        summary: "Involving employees in sustainability practices and building shared ownership across departments.",
        areas: ["employees"],
    },
];

export const LEARNING_STATUSES = [
    { key: "not_started", label: "Not Started" },
    { key: "in_progress", label: "In Progress" },
    { key: "completed", label: "Completed" },
];
